<script setup>
import { useUiStore } from '@/store/uiStore'
import { storeToRefs } from 'pinia'

const ui = useUiStore()

const { sidebarColor } = storeToRefs(ui)

defineProps({
    links: {
        type: Array,
        required: true,
    },
})

const cleanLabel = (label) => label.replace(/&laquo;|&raquo;/g, "").trim()
</script>

<template>
    <ArgonPagination :color="sidebarColor" class="d-flex justify-content-center mt-3" size="md" v-if="links.length">
        <ArgonPaginationItem v-for="(link, index) in links" :key="index" :label="cleanLabel(link.label)"
            :active="link.active" :disabled="!link.url" :prev="link.label.includes('laquo')"
            :next="link.label.includes('raquo')" @click="$emit('pagina', link.url)" />
    </ArgonPagination>
</template>
